import React from 'react';
import { Anchor, Group, Stack, Text } from '@mantine/core';
import RightArrowPartner from '../assets/images/module/general/RightArrowPartner.svg';

// Compact empty state for use inside modals. Full screens keep using the larger
// neoverv EmptyStateContainer; the prop names match it so a modal can switch by
// renaming the component. The button is rendered as a link, styled like
// "Verteilerwerte anpassen" in CostPositionValuesModal.
const EmptyStateContainerForModals = ({ heading, subheading, icon, showBtn = true, btnText, btnHandler }) => (
  <Group
    wrap="nowrap"
    align="flex-start"
    gap={12}
    style={{ padding: 10, border: '1px solid #EDEDF5', borderRadius: 4, background: '#F8F8FC' }}
  >
    {icon &&
    <div style={{ width: 36, height: 36, borderRadius: '4px', background: '#EEEEFF', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
      <img src={icon} alt="" style={{ width: 16, height: 16, objectFit: 'contain' }} />
    </div>}
    <Stack gap={2} style={{ minWidth: 0 }}>
      {heading &&
      <Text style={{ fontSize: 14, fontWeight: 500, fontFamily: 'Inter, sans-serif', color: '#0E0E1D' }}>
        {heading}
      </Text>}
      {subheading &&
      <Text style={{ fontSize: '12px', fontFamily: 'Inter, sans-serif', color: '#727293' }}>
        {subheading}
      </Text>}
      {showBtn && btnText &&
      <Anchor
        component="button"
        type="button"
        underline="never"
        onClick={btnHandler}
        style={{ fontSize: '12px', fontWeight: '400', fontFamily: 'Inter, sans-serif', color: '#5555FF', display: 'inline-flex', alignItems: 'center', gap: 5, alignSelf: 'flex-start', marginTop: 4 }}
      >
        {btnText}
        <img src={RightArrowPartner} alt="" style={{ marginTop: '3px', width: '12px' }} />
      </Anchor>}
    </Stack>
  </Group>
);

export default EmptyStateContainerForModals;
